'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageIsOwned = exports.SSRstorageCreator = exports.SSRAuthenticator = exports.authenticateClient = exports.ClientAuthMiddleware = exports.ClientStorageCreator = exports.updateSelectedProfile = exports.ClientAuthenticator = exports.deconstructProfiles = undefined;

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxSimpleAuth = require('redux-simple-auth');

var _googleTagManager = require('./google-tag-manager');

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _isomorphicHelpers = require('./isomorphic-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var COOKIE_STORE_NAME = 'doctify-store';
var AUTHENTICATOR_NAME = 'doctify';
var secondsFromNow = function secondsFromNow(seconds) {
  return new Date(Date.now() + seconds * 1000);
};

var STORAGE_REFERENCE = void 0;

var deconstructProfiles = exports.deconstructProfiles = function deconstructProfiles(profiles) {
  if ((0, _isArray3.default)(profiles)) {
    /**
    this case seem to happen only on the patient side.
    **/
    return profiles.map(function (profile) {
      return _extends({}, profile, {
        type: 'patient'
      });
    });
  }
  var specialists = profiles.specialist ? Object.keys(profiles.specialist).map(function (key) {
    return Object.assign(profiles.specialist[key], { type: 'specialist' });
  }).sort(function (a, b) {
    if (a.lastname < b.lastname) {
      return -1;
    }
    if (a.lastname > b.lastname) {
      return 1;
    }

    if (a.lastname === b.lastname) {
      // if last names are identical, then we sort by a first name
      if (a.firstname < b.firstname) {
        return -1;
      }

      if (a.firstname > b.firstname) {
        return 1;
      }
      return 0;
    }

    return 0;
  }) : [];
  var practices = profiles.practice ? Object.keys(profiles.practice).map(function (key) {
    return Object.assign(profiles.practice[key], {
      type: 'practice',
      name: profiles.practice[key].practice_name
    });
  }).sort(function (a, b) {
    if (a.name < b.name) {
      return -1;
    }

    if (a.name > b.name) {
      return 1;
    }

    return 0;
  }) : [];
  return [].concat(_toConsumableArray(practices), _toConsumableArray(specialists));
};

var processLogin = function processLogin(result) {
  if (result.data && result.data.profiles) {
    result.data.selectedProfile = deconstructProfiles(result.data.profiles)[0] || {};
    result.data.selectedProfile.id = result.data.selectedProfile.id || result.data.selectedProfile.uuid || result.data.selectedProfile.profile_id;
    result.data.selectedProfile.uri_id = result.data.selectedProfile.uri_id || result.data.selectedProfile.profile_uri_id;
    if (result.data.selectedProfile.type === 'patient') {
      return (0, _api2.default)({
        url: '/patients/' + result.data.selectedProfile.id,
        method: 'GET',
        auth: result.data.auth_token
      }).then(function (_ref) {
        var data = _ref.data;

        result.data.selectedProfile = _extends({}, result.data.selectedProfile, data.patient, {
          name: data.patient && data.patient.firstname + ' ' + data.patient.lastname
        });
        return result.data;
      });
    }
    return Promise.resolve(result.data);
  }
  return Promise.resolve(result.data);
};

var ClientAuthenticator = exports.ClientAuthenticator = (0, _reduxSimpleAuth.createAuthenticator)({
  name: AUTHENTICATOR_NAME,
  authenticate: function authenticate(data) {
    return (0, _api2.default)({
      url: '/auth/login',
      method: 'POST',
      data: data
    }).then(function (result) {
      (0, _googleTagManager.fireGTMevent)('login_button_click');
      return processLogin(result);
    });
  },
  restore: function restore(data) {
    if (data && data.auth_token) {
      return (0, _api2.default)({
        url: '/auth/restore',
        method: 'POST',
        auth: data.auth_token
      }).then(function (response) {
        return processLogin(response);
      }).then(function (processedResponse) {
        Object.assign(STORAGE_REFERENCE.authenticated, processedResponse);
        setAngularCompatibility(STORAGE_REFERENCE);
        return Promise.resolve();
      }).catch(function () {
        return Promise.reject();
      });
    } else {
      return Promise.reject();
    }
  }
});

var setAngularCompatibility = function setAngularCompatibility(cookie) {
  if (!(0, _isomorphicHelpers.isServerSide)()) {
    var data = cookie.authenticated ? _extends({}, cookie.authenticated, {
      profiles: cookie.authenticated.profiles && deconstructProfiles(cookie.authenticated.profiles).map(function (profile) {
        return _extends({
          id: profile.profile_id || profile.uuid,
          uri_id: profile.profile_uri_id
        }, profile);
      }) || []
    }) : {};
    localStorage.setItem('ls.loggedIn', JSON.stringify(data && data.auth_token ? true : false));
    localStorage.setItem('ls.currentUser', JSON.stringify(data || {}));
    localStorage.setItem('ls.availableProfiles', JSON.stringify(data && data.profiles || []));
    localStorage.setItem('ls.currentProfile', JSON.stringify(data && data.selectedProfile));
  }
};

var updateSelectedProfile = exports.updateSelectedProfile = function updateSelectedProfile(profile) {
  !(0, _isomorphicHelpers.isServerSide)() && localStorage.setItem('ls.currentProfile', JSON.stringify(profile));
};

var ClientStorageCreator = exports.ClientStorageCreator = function ClientStorageCreator() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$name = _ref2.name,
      name = _ref2$name === undefined ? COOKIE_STORE_NAME : _ref2$name,
      _ref2$path = _ref2.path,
      path = _ref2$path === undefined ? '/' : _ref2$path,
      _ref2$domain = _ref2.domain,
      domain = _ref2$domain === undefined ? null : _ref2$domain,
      _ref2$secure = _ref2.secure,
      secure = _ref2$secure === undefined ? false : _ref2$secure,
      _ref2$expires = _ref2.expires,
      expires = _ref2$expires === undefined ? null : _ref2$expires;

  return {
    persist: function persist(cookie) {
      /**
      We write on both the local storage for backward compatiblity with
      Angular and the cookies
      **/
      var cookieToWrite = cookie && cookie.authenticated && cookie.authenticated.auth_token ? {
        authenticated: {
          auth_token: cookie.authenticated.auth_token,
          id: cookie.authenticated.account && cookie.authenticated.account.id
        }
      } : null;

      setAngularCompatibility(cookie);
      _jsCookie2.default.set(name, cookieToWrite, {
        domain: domain,
        path: path,
        secure: secure,
        expires: expires && secondsFromNow(expires)
      });
    },
    restore: function restore() {
      /**
      we only trust the cookies to get the data, there should be no need to
      rewrite the local storage, but let's just be sure.
      **/
      STORAGE_REFERENCE = _jsCookie2.default.getJSON(name) || {};
      return STORAGE_REFERENCE;
    }
  };
};

var ClientAuthMiddleware = exports.ClientAuthMiddleware = (0, _reduxSimpleAuth.createAuthMiddleware)({
  authenticator: ClientAuthenticator,
  storage: ClientStorageCreator({
    name: COOKIE_STORE_NAME
  })
});

var authenticateClient = exports.authenticateClient = function authenticateClient(data) {
  return (0, _reduxSimpleAuth.authenticate)(AUTHENTICATOR_NAME, {
    name: data.email,
    password: data.password
  });
};

var SSRAuthenticator = exports.SSRAuthenticator = (0, _reduxSimpleAuth.createAuthenticator)({
  name: AUTHENTICATOR_NAME,
  authenticate: function authenticate() {
    /*this should not be used in anyway*/
    console.error('Trying to authenticate on server-side'); //eslint-disable-line
    return Promise.reject();
  },
  restore: function restore(data) {
    if (data && data.auth_token) {
      return Promise.resolve(data);
    } else {
      return Promise.reject();
    }
  }
});

var SSRstorageCreator = exports.SSRstorageCreator = function SSRstorageCreator(request) {
  return {
    name: COOKIE_STORE_NAME,
    persist: function persist() {},
    /* no op really, we are on the server side.*/
    restore: function restore() {
      return request.cookies && request.cookies[COOKIE_STORE_NAME] && JSON.parse(request.cookies[COOKIE_STORE_NAME]);
    }
  };
};

var pageIsOwned = exports.pageIsOwned = function pageIsOwned(session, id, pageType) {
  var canViewUnapprovedPage = false;
  var profiles = session && session.profiles && session.profiles && session.profiles[pageType] || [];
  Object.keys(profiles).forEach(function (profile) {
    if (profile === id && profiles[profile].permissions[pageType + '_details'].view) {
      canViewUnapprovedPage = true;
    }
  });
  return canViewUnapprovedPage;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/authentication.js
// module id = 1496
// module chunks = 0